import React from 'react'
import ConnectPageStyle from './Style'
import { CardDetails } from 'components/SocialMediaCard/CardDetails'
import SocialMediaCard from 'components/SocialMediaCard/SocialMediaCard'
import {
  IResolveParams,
  LoginSocialFacebook,
} from 'reactjs-social-login'
import { REDDIT_OAUTH } from 'constants/url'
import { REDDIT_REDIRECT_URL } from 'constants/oauth2'
import Fade from '@mui/material/Fade'
import { useNavigate } from 'react-router-dom'
import { Platform, useAddMediaAccountMutation } from 'graphql/generated/graphql'
import Spinner from 'components/Spinner/Spinner'

const REDIRECT_URI = 'https://app.nalapod.com/oauth2/cb'
//  'http://localhost:8001/oauth2/cb'
// window.location.href

export default function Connect(): JSX.Element {
  const [checked] = React.useState(true)
  const oauthUrl = REDDIT_OAUTH(REDDIT_REDIRECT_URL)
  const [addMediaAccount, { loading }] = useAddMediaAccountMutation()
  const navigate = useNavigate()
  // const instagramOAUTHURL = INSTAGRAM_OAUTH(
  //   'https://app.nalapod.com/instagram/code',
  //   '2158302944378302',
  //   'user_profile,user_media,instagram_basic,instagram_content_publish' // TODO: Add right scopes
  // )

  const CLIENT_KEY = 'awig64q0ln2v71q3'
  const TIKTOK_REDIRECT = 'https://app.nalapod.com/tiktok/code'

  const csrfState = Math.random().toString(36).substring(2)

  let url = 'https://www.tiktok.com/v2/auth/authorize/'

  // the following params need to be in `application/x-www-form-urlencoded` format.
  url += `?client_key=${CLIENT_KEY}`
  url +=
    '&scope=user.info.basic,video.publish,video.upload,video.list,user.info.stats,user.info.profile'
  url += '&response_type=code'
  url += `&redirect_uri=${TIKTOK_REDIRECT}`
  url += '&state=' + csrfState

  const handleConnect = (): void => {
    window.location.href = oauthUrl
  }

const GOOGLE_CLIENT_ID = '956291361998-kektm3un1rkmueabqnhg7nbor0l6hj0p.apps.googleusercontent.com';
const GOOGLE_REDIRECT_URI = "https://app.nalapod.com/youtube/code";

const handleGoogleConnect = () => {
  const params = new URLSearchParams({
    client_id: GOOGLE_CLIENT_ID,
    redirect_uri: GOOGLE_REDIRECT_URI,
    response_type: "code",
    access_type: "offline",
    scope: "https://www.googleapis.com/auth/youtube.force-ssl",
    prompt: "consent",
  });
  
  window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
};

  return (
    <>
      <Fade in={checked} timeout={1500}>
        <ConnectPageStyle.ContainerStyle>
          <ConnectPageStyle.PageTitle>
            Connect your social media
          </ConnectPageStyle.PageTitle>
          <ConnectPageStyle.SocialMediaContainer>
            <ConnectPageStyle.GridStyle container>
            <div>
              <SocialMediaCard
                platformName={CardDetails[4].platformName}
                description={CardDetails[4].description}
                icon={CardDetails[4].icon}
                onClick={handleGoogleConnect}
              />
            </div>
              {/* <div>
                <SocialMediaCard
                  platformName={CardDetails[0].platformName}
                  icon={CardDetails[0].icon}
                  description={CardDetails[0].description}
                  onClick={() => {
                    window.location.href = instagramOAUTHURL
                  }}
                />
              </div> */}
              <LoginSocialFacebook
                isOnlyGetToken
                onResolve={({ provider, data }: IResolveParams) => {
                  console.log({ data })
                  localStorage.setItem(
                    'facebook_access_token',
                    data?.access_token
                  )
                  void addMediaAccount({
                    variables: {
                      accessToken: data?.accessToken,
                      platform: Platform.Instagram,
                    },
                  })
                    .then(() => {
                      navigate(-1)
                    })
                    .catch((err) => {
                      alert('Error connecting account')
                      console.log(err)
                    })
                }}
                onReject={(err: any) => {
                  console.log(err)
                  alert('Something went wrong')
                }}
                appId="733103725206752"
                scope="instagram_content_publish,instagram_basic,pages_show_list,public_profile,business_management,instagram_manage_insights,pages_read_engagement,instagram_manage_comments,pages_messaging,pages_manage_metadata,instagram_manage_messages,pages_manage_posts,pages_manage_engagement,pages_read_user_content"
              >
                <SocialMediaCard
                  platformName={CardDetails[1].platformName}
                  description={CardDetails[1].description}
                  icon={CardDetails[1].icon}
                />
              </LoginSocialFacebook>
              {/* <LoginSocialTiktok
                client_key={CLIENT_KEY}
                redirect_uri="https://7ee4-109-92-170-1.ngrok-free.app/tiktok/code/"
                scope={'user.info.basic'}
                state={'_tiktok_'}
                onResolve={({ provider, data }) => {
                  console.log({ provider, data })
                }}
                onReject={(err) => {
                  console.log(err)
                }}
              >
                <SocialMediaCard
                  platformName={CardDetails[6].platformName}
                  description={CardDetails[6].description}
                  icon={CardDetails[6].icon}
                />
              </LoginSocialTiktok> */}
              <div>
                <a href={url}>
                  <SocialMediaCard
                    platformName={CardDetails[6].platformName}
                    description={CardDetails[6].description}
                    icon={CardDetails[6].icon}
                  />
                </a>
              </div>
              <div>
                <SocialMediaCard
                  onClick={handleConnect}
                  platformName={CardDetails[5].platformName}
                  description={CardDetails[5].description}
                  icon={CardDetails[5].icon}
                />
              </div>
            </ConnectPageStyle.GridStyle>
          </ConnectPageStyle.SocialMediaContainer>

          <ConnectPageStyle.LinkStyle to="/">
            Skip this step
          </ConnectPageStyle.LinkStyle>
          {loading && (
            <div
              style={{
                position: 'absolute' as 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
              }}
            >
              <Spinner />
            </div>
          )}
        </ConnectPageStyle.ContainerStyle>
      </Fade>
    </>
  )
}
